import { ResolverTag } from '@ps/web-core-enums';
import { CrossPlatformLink, useResolver } from '@ps/web-shared-components';
import React from 'react';

import CMSHTML from '../../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../../CMSImage/CMSImage';
import type { Props } from '../../../TopHeader';

import styles from './DKHeaderContent.scss';

const DKHeaderContent: React.FC<Props> = ({ regulatory_header: [{ texts, icons }] }) => {
  const responsibleGamingUrl = useResolver(ResolverTag.HelpResponsibleGaming);
  const regulatorUrl = useResolver(ResolverTag.DKRegulatorLogo);

  return (
    <div className={styles.linksContainer}>
      <CrossPlatformLink href={responsibleGamingUrl} className={styles.link} openLinkInNewTab>
        <CMSHTML content={texts[0].content} />
      </CrossPlatformLink>
      <CrossPlatformLink
        href="https://www.stopspillet.dk/"
        className={styles.link}
        openLinkInNewTab
      >
        <CMSHTML content={texts[1].content} />
      </CrossPlatformLink>
      <CrossPlatformLink href="https://www.rofus.nu/" className={styles.link} openLinkInNewTab>
        <CMSHTML content={texts[2].content} />
      </CrossPlatformLink>
      <div className={styles.iconsContainer}>
        <CrossPlatformLink href={responsibleGamingUrl} openLinkInNewTab>
          <CMSImage className={styles.plus18} {...icons[0]} />
        </CrossPlatformLink>
        <CrossPlatformLink href={regulatorUrl} openLinkInNewTab>
          <CMSImage className={styles.dkLogo} {...icons[1]} />
        </CrossPlatformLink>
      </div>
    </div>
  );
};

export default DKHeaderContent;
